import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Alert from "@mui/material/Alert";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { headerData } from "../../data/headerCostum";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import { useLocalStorage } from "../../auth/useLocalStorage";
import SecurityIcon from "@mui/icons-material/Security";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="darkslategray"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://diskominfo.makassarkota.go.id/">
        Diskominfo Kota Makassar
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#1dc39f',
    },
    secondary: {
      main: '#8ff9ab',
    },
  },
  typography: {
    h5: {
      fontWeight: 600,
    },
  },
});

const DaftarLongwisMonitoringCCTV = () => {
  const navigate = useNavigate();
  const [longwis, setLongwis] = useLocalStorage("longwis", null);

  const [swalProps, setSwalProps] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({
    id: null,
    kecamatan: null,
    kelurahan: null,
    longwis: null,
    alamat: null,
    nama_pic: '',
    kontak_pic: '',
    tanggal: null,
    status: ''
  });

  const steps = ['Pilih Kecamatan', 'Pilih Kelurahan', 'Pilih Longwis', 'Pilih Alamat', 'Konfirmasi'];

  const [kecamatan, setKecamatan] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }])

  const [kelurahan, setKelurahan] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }])

  const [data_longwis, setDataLongwis] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }])

  const [data_alamat, setDataAlamat] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }])

  const [list_longwis, setListLongwis] = useState(null)

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => {
    event.preventDefault();
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getLongwisData = () => {
    fetch(process.env.REACT_APP_API_URL + "api/longwis", {
      method: "get",
      headers: headerData
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Gagal mengambil data longwis');
        }
        return res.json();
      })
      .then((res) => {
        if (res && Array.isArray(res) && res.length > 0) {
          setListLongwis(res);
          getKecData(res)
        } else {
          setSwalProps({
            show: true,
            title: "Gagal",
            icon: "error",
            text: "Data longwis tidak ditemukan atau kosong",
          });
        }
      })
      .catch((err) => {
        console.error('Error fetching longwis data:', err);
        setSwalProps({
          show: true,
          title: "Gagal",
          icon: "error",
          text: err.message || "Terjadi kesalahan saat mengambil data",
        });
      });
  }

  const getKecData = useCallback((data) => {
    let kecamatan = [];
    let dataKecamatan = [];
    data.forEach((items, index) => {
      if (kecamatan.includes(items.kecamatan)) {
        return
      } else {
        kecamatan.push(items.kecamatan)
        dataKecamatan.push({ nama: items.kecamatan, id: index });
      }
    })
    setKecamatan(dataKecamatan)
  }, [setKecamatan])

  const kecHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item => item.kecamatan === e.nama);
      let kelurahan = [];
      let dataKelurahan = [];
      filteredData.forEach((items, index) => {
        if (kelurahan.includes(items.kelurahan)) {
          return
        } else {
          kelurahan.push(items.kelurahan)
          dataKelurahan.push({ nama: items.kelurahan, id: index });
        }
      })
      setKelurahan(dataKelurahan);
      // Reset subsequent selections when kecamatan changes
      setDataLongwis([{ id: 1, nama: 'Pilih kelurahan terlebih dahulu' }]);
      setDataAlamat([{ id: 1, nama: 'Pilih longwis terlebih dahulu' }]);
      setData(prevData => ({
        ...prevData,
        kelurahan: null,
        longwis: null,
        alamat: null,
        nama_pic: '',
        kontak_pic: '',
        id: null
      }));
      setCurrentStep(1);
    }
  }, [list_longwis]);

  const kelHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item =>
        item.kecamatan === data.kecamatan?.nama && item.kelurahan === e.nama
      );
      let longwis = [];
      let dataLongwis = [];
      filteredData.forEach((items, index) => {
        if (longwis.includes(items.nama_longwis)) {
          return
        } else {
          longwis.push(items.nama_longwis)
          dataLongwis.push({ nama: items.nama_longwis, id: index });
        }
      })
      setDataLongwis(dataLongwis);
      // Reset subsequent selections when kelurahan changes
      setDataAlamat([{ id: 1, nama: 'Pilih longwis terlebih dahulu' }]);
      setData(prevData => ({
        ...prevData,
        longwis: null,
        alamat: null,
        nama_pic: '',
        kontak_pic: '',
        id: null
      }));
      setCurrentStep(2);
    }
  }, [list_longwis, data.kecamatan]);

  const alamatHanlde = useCallback((e) => {
    if (e && data.kecamatan && data.kelurahan) {
      const filteredData = [...list_longwis].filter(item =>
        item.kecamatan === data.kecamatan.nama &&
        item.kelurahan === data.kelurahan.nama &&
        item.nama_longwis === e.nama
      );

      let dataAlamat = [];
      let alamat_longwis = [];

      filteredData.forEach((items, index) => {
        alamat_longwis.push(items.alamat)
        dataAlamat.push({ nama: items.alamat, id: index });
      });

      setDataAlamat(dataAlamat);
      // Reset PIC info when longwis changes
      setData(prevData => ({
        ...prevData,
        alamat: null,
        nama_pic: '',
        kontak_pic: '',
        id: null
      }));
      setCurrentStep(3);
    }
  }, [list_longwis, data.kecamatan, data.kelurahan]);

  const picHandle = useCallback((e) => {
    if (e && data.kecamatan && data.kelurahan && data.longwis) {
      const filteredData = [...list_longwis].filter(item =>
        item.kecamatan === data.kecamatan.nama &&
        item.kelurahan === data.kelurahan.nama &&
        item.nama_longwis === data.longwis.nama &&
        item.alamat === e.nama
      );

      if (filteredData.length > 0) {
        const selectedItem = filteredData[0]; // Ambil item pertama yang cocok

        // Try multiple field name variations for nama_pic
        let nama_pic_value = selectedItem.nama_pic || selectedItem.pic_name || selectedItem.namaPic || selectedItem.nama || '';
        let kontak_pic_value = selectedItem.kontak_pic || selectedItem.pic_contact || selectedItem.kontakPic || selectedItem.kontak || '';

        setData(prevData => ({
          ...prevData,
          id: selectedItem.id,
          nama_pic: nama_pic_value || 'Tidak tersedia',
          kontak_pic: kontak_pic_value || 'Tidak tersedia'
        }));
        setCurrentStep(4);
      } else {
        console.warn('No matching data found for alamat:', e.nama);
        setData(prevData => ({
          ...prevData,
          id: null,
          nama_pic: 'Data tidak ditemukan',
          kontak_pic: 'Data tidak ditemukan'
        }));
        setCurrentStep(4); // Still show the PIC section even if no data found
      }
    }
  }, [list_longwis, data.kecamatan, data.kelurahan, data.longwis]);

  const sendData = () => {
    // Validasi yang lebih komprehensif
    if (!data.kecamatan || !data.kelurahan || !data.longwis || !data.alamat) {
      setSwalProps({
        show: true,
        title: "Error",
        icon: "error",
        text: "Silakan lengkapi semua data terlebih dahulu.",
      });
      return;
    }

    if (!data.id || !data.nama_pic || !data.kontak_pic) {
      setSwalProps({
        show: true,
        title: "Error",
        icon: "error",
        text: "Data PIC tidak ditemukan. Silakan pilih ulang alamat longwis.",
      });
      return;
    }

    navigate("/pic/monitoring-cctv", {
      state: {
        data_longwis: {
          id: data.id,
          nama_lokasi: `${data.longwis?.nama} - ${data.alamat?.nama}`,
          kecamatan: data.kecamatan?.nama,
          kelurahan: data.kelurahan?.nama,
          nama_longwis: data.longwis?.nama,
          alamat: data.alamat?.nama,
          nama_pic: data.nama_pic,
          kontak_pic: data.kontak_pic,
        },
      },
    });
    setOpenDialog(false);
  };

  useEffect(() => {
    if (!list_longwis) {
      getLongwisData();
    }
  }, [list_longwis]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #e91e63 0%, #f48fb1 100%)',
        py: 3
      }}
    >
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="md">
          <CssBaseline />
          <SweetAlert2
            {...swalProps}
            didClose={() => {
              setSwalProps({});
            }}
          />
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              align="center"
              sx={{ justifyItems: "center", bgcolor: '#e91e63', color: 'white' }}
              id="alert-dialog-title"
            >
              Konfirmasi Data
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <DialogContentText id="alert-dialog-description" sx={{ mb: 2 }}>
                Pastikan data yang dipilih sudah benar:
              </DialogContentText>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Kecamatan:</strong> {data.kecamatan?.nama || '-'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Kelurahan:</strong> {data.kelurahan?.nama || '-'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Longwis:</strong> {data.longwis?.nama || '-'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Alamat:</strong> {data.alamat?.nama || '-'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>PIC:</strong> {data.nama_pic || '-'}
                </Typography>
                <Typography variant="body2">
                  <strong>Kontak PIC:</strong> {data.kontak_pic || '-'}
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              sx={{
                justifyContent: "space-between",
                p: 3
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseDialog}
                sx={{
                  borderColor: 'error.main',
                  color: 'error.main',
                  '&:hover': {
                    borderColor: 'error.dark',
                    backgroundColor: 'error.light'
                  }
                }}
              >
                Kembali
              </Button>
              <Button
                variant="contained"
                onClick={sendData}
                autoFocus
                sx={{
                  background: 'linear-gradient(90deg, #e91e63, #f48fb1)',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #c2185b, #f06292)',
                  }
                }}
              >
                Lanjutkan
              </Button>
            </DialogActions>
          </Dialog>

          <Paper
            elevation={10}
            sx={{
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: 3,
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
            }}
          >
            {/* Header */}
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: '#e91e63',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                boxShadow: 3
              }}
            >
              <SecurityIcon sx={{ fontSize: 40, color: 'white' }} />
            </Box>

            <Typography component="h1" variant="h5" sx={{ mb: 1, color: '#e91e63' }}>
              Monitoring CCTV Longwis
            </Typography>

            <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', textAlign: 'center' }}>
              Silakan pilih lokasi Longwis untuk monitoring CCTV
            </Typography>

            {/* Stepper */}
            <Box sx={{ width: '100%', mb: 4 }}>
              <Stepper activeStep={currentStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            <Box component="form" onSubmit={handleOpenDialog} sx={{ width: '100%', maxWidth: 600 }}>
              {/* Kecamatan */}
              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 0 ? '#e91e63' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <BusinessIcon color={currentStep >= 0 ? 'error' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Kecamatan</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="kecamatan"
                    options={kecamatan ? kecamatan : [{ nama: "Loading..." }]}
                    value={data.kecamatan}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => {
                      kecHandle(newValue);
                      setData({ ...data, kecamatan: newValue });
                    }}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Pilih Kecamatan"
                        variant="outlined"
                      />
                    )}
                  />
                </CardContent>
              </Card>

              {/* Kelurahan */}
              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 1 ? '#e91e63' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <HomeIcon color={currentStep >= 1 ? 'error' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Kelurahan</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="kelurahan"
                    options={kelurahan ? kelurahan : [{ id: 1, nama: "Pilih kecamatan terlebih dahulu" }]}
                    value={data.kelurahan}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => {
                      kelHandle(newValue);
                      setData({ ...data, kelurahan: newValue });
                    }}
                    disabled={!data.kecamatan}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Pilih Kelurahan"
                        variant="outlined"
                      />
                    )}
                  />
                </CardContent>
              </Card>

              {/* Longwis */}
              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 2 ? '#e91e63' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <LocationOnIcon color={currentStep >= 2 ? 'error' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Nama Longwis</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="longwis"
                    options={data_longwis ? data_longwis : [{ id: 1, nama: "Pilih kelurahan terlebih dahulu" }]}
                    value={data.longwis}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => {
                      alamatHanlde(newValue)
                      setData({ ...data, longwis: newValue });
                    }}
                    disabled={!data.kelurahan}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Pilih Nama Lorong Wisata"
                        variant="outlined"
                      />
                    )}
                  />
                </CardContent>
              </Card>

              {/* Alamat */}
              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 3 ? '#e91e63' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <HomeIcon color={currentStep >= 3 ? 'error' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Alamat Longwis</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="alamat_longwis"
                    options={data_alamat ? data_alamat : [{ id: 1, nama: "Pilih longwis terlebih dahulu" }]}
                    value={data.alamat}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => {
                      setData({ ...data, alamat: newValue });
                      if (newValue) {
                        picHandle(newValue);
                      } else {
                        // Clear PIC info if alamat is cleared
                        setData(prevData => ({
                          ...prevData,
                          alamat: null,
                          nama_pic: '',
                          kontak_pic: '',
                          id: null
                        }));
                        setCurrentStep(3);
                      }
                    }}
                    disabled={!data.longwis}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Pilih Alamat Lorong Wisata"
                        variant="outlined"
                      />
                    )}
                  />
                </CardContent>
              </Card>

              {/* PIC Information */}
              {currentStep >= 4 && (
                <Card sx={{ mb: 3, border: '1px solid', borderColor: 'success.main', bgcolor: 'success.light' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <PersonIcon color="success" sx={{ mr: 1 }} />
                      <Typography variant="h6" color="success.dark">Informasi PIC</Typography>
                    </Box>
                    <TextField
                      fullWidth
                      label="Nama PIC"
                      value={data.nama_pic}
                      disabled
                      sx={{ mb: 2 }}
                      variant="outlined"
                    />
                    <TextField
                      fullWidth
                      label="Kontak PIC"
                      value={data.kontak_pic}
                      disabled
                      variant="outlined"
                    />
                  </CardContent>
                </Card>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={currentStep < 4}
                sx={{
                  py: 1.5,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  background: currentStep >= 4 ? 'linear-gradient(90deg, #e91e63, #f48fb1)' : 'grey.400',
                  textTransform: 'none',
                  '&:hover': {
                    background: currentStep >= 4 ? 'linear-gradient(90deg, #c2185b, #f06292)' : 'grey.500',
                  }
                }}
              >
                {currentStep >= 4 ? 'Lanjut ke Monitoring CCTV' : 'Lengkapi Data Terlebih Dahulu'}
              </Button>
            </Box>

            <Copyright sx={{ mt: 4 }} />
          </Paper>
        </Container>
      </ThemeProvider>
    </Box>
  );
};

export default DaftarLongwisMonitoringCCTV;
